import { TaggingContainer } from '@core/model/domain/taggingTracker';
import {
  NotificationConfiguration,
  NotificationMethod,
} from '@core/model/framework/notificationConfiguration';
import { environment } from '@environments/environment';

export type NotificationsConfiguration = {
  webauth: NotificationConfiguration;
  caseState: NotificationConfiguration;
  bankAccountAnalysisCompletion: NotificationConfiguration;
};

export type KernelConfiguration = {
  isInMemory: boolean;
  env: 'dev' | 'preprod' | 'prod';
  openBankingBaseUrl: string;
  notificationMethod: NotificationMethod;
  notifications: NotificationsConfiguration;
  isTrackingEnabled: boolean;
  isWebauthQrCodeEnabled: boolean;
  taggingContainers: Array<TaggingContainer>;
};

export function buildConfiguration(): KernelConfiguration {
  const isInMemory = false;

  return {
    env: environment.env,
    isInMemory: isInMemory,
    openBankingBaseUrl: environment.urlOpenBanking,
    notificationMethod: environment.notificationMethod,
    notifications: {
      webauth: {
        timeoutInSeconds: environment.webauthNotification.timeoutInSeconds,
        intervalInSeconds: environment.webauthNotification.intervalInSeconds,
        initialDelayInSeconds: environment.webauthNotification.initialDelayInSeconds,
      },
      caseState: {
        timeoutInSeconds: environment.caseStateNotification.timeoutInSeconds,
        intervalInSeconds: environment.caseStateNotification.intervalInSeconds,
      },
      bankAccountAnalysisCompletion: {
        timeoutInSeconds: environment.bankAccountAnalysisCompletion.timeoutInSeconds,
        intervalInSeconds: environment.bankAccountAnalysisCompletion.intervalInSeconds,
      },
    },
    isTrackingEnabled: environment.isTrackingEnabled,
    isWebauthQrCodeEnabled: environment.isWebauthQrCodeEnabled,
    taggingContainers: environment.taggingContainers,
  };
}
